import { format, getTime, formatDistanceToNow } from 'date-fns';
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';

type InputValue = Date | string | number | null | undefined;

// Fuseau horaire par défaut, à adapter à ton cas (Europe/Paris ici)
const DEFAULT_TIMEZONE = 'Europe/Paris';

/**
 * Formate une date dans un fuseau horaire donné, selon le format donné.
 */
export function fDate(
  date: InputValue,
  newFormat: string = 'dd MMM yyyy',
  timeZone: string = DEFAULT_TIMEZONE
) {
  if (!date) return '';
  // Utilisation de date-fns-tz pour garantir la gestion du fuseau
  return formatInTimeZone(new Date(date), timeZone, newFormat);
}

/**
 * Formate date+heure dans un fuseau horaire donné
 */
export function fDateTime(
  date: InputValue,
  newFormat: string = 'dd MMM yyyy HH:mm',
  timeZone: string = DEFAULT_TIMEZONE
) {
  if (!date) return '';
  return formatInTimeZone(new Date(date), timeZone, newFormat);
}

/**
 * Retourne un timestamp (ms) de la date (toujours en UTC JS natif)
 */
export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

/**
 * Format custom dans un timeZone
 */
export function fCustomDate(
  date: InputValue,
  newFormat: string = "EEE, dd MMM yyyy HH:mm:ss 'zzz'",
  timeZone: string = DEFAULT_TIMEZONE
) {
  if (!date) return '';
  return formatInTimeZone(new Date(date), timeZone, newFormat);
}

/**
 * Distance à maintenant, pas besoin de fuseau
 */
export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), { addSuffix: true })
    : '';
}

export function getDateRangeIso(start: any, end: any, timeZone: any) {
  // On force l'heure à midi (12:00) pour éviter le bug de timezone
  const startDate = new Date(start);
  startDate.setHours(12, 0, 0, 0);

  const endDate = new Date(end);
  endDate.setHours(12, 0, 0, 0);

  // Conversion timezone inchangée
  const startUtc = zonedTimeToUtc(startDate, timeZone).toISOString();
  const endUtc = zonedTimeToUtc(endDate, timeZone).toISOString();

  return { start: startUtc, end: endUtc };
}
